module.exports = __webpack_public_path__ + "img/watt_hour_meter.b911e07e.svg";